import React, { useState, useEffect } from "react";
import { Modal, Button, Flex, Text } from "@mantine/core";
import Barcode from "react-barcode";
import "@mantine/core/styles.css";

const products_api = {
  saveBarcodeReferences: async (payload) => {
    console.log("📦 Mock API Called: saveBarcodeReferences()");
    console.log("Payload:", payload);
    return new Promise((resolve) =>
      setTimeout(() => resolve({ success: true }), 800)
    );
  },
};

export default function BarcodeManager({
  barcodeData,
  productList = [],
  batchList = [],
  applicableDate = null,
  show,
  onClose,
  initialQty,
}) {
  const [selectedBarcodes, setSelectedBarcodes] = useState([]);
  const [showReportModal, setShowReportModal] = useState(false);
  const [emptyOffset, setEmptyOffset] = useState(0);

  const productCode = barcodeData?.product_code || "-";
  const productName = barcodeData?.product_name || "-";
  const batchCode = barcodeData?.batch_code || "-";
  const price = barcodeData?.price || barcodeData?.mrp || "-";

  const shortBarcode = `${batchCode}`;

  useEffect(() => {
    let safeArray = [];
    if (initialQty > 0) {
      safeArray = Array(initialQty).fill(shortBarcode);
    }
    setSelectedBarcodes(safeArray);
    console.log("📌 PROPS RECEIVED SAFE:", safeArray);
  }, [barcodeData, initialQty, shortBarcode]);

  const removeBarcode = (idx) => {
    setSelectedBarcodes((prev) => prev.filter((_, i) => i !== idx));
  };

  const buildReportData = () => {
    const reportMap = {};
    const barcodes = Array.isArray(selectedBarcodes) ? selectedBarcodes : [];

    barcodes.forEach((barcodeValue) => {
      const val = String(barcodeValue || "").trim();

      let matchedBatch = batchList.find(
        (b) =>
          b.batch_code &&
          String(b.batch_code).trim().toLowerCase() === val.toLowerCase()
      );

      if (!matchedBatch) {
        matchedBatch = batchList.find(
          (b) =>
            b.batch_code &&
            val.toLowerCase().includes(String(b.batch_code).toLowerCase())
        );
      }

      let productCode = matchedBatch?.product_code || barcodeData?.product_code || null;
      let batchCode = matchedBatch?.batch_code || barcodeData?.batch_code || null;
      let productNameLocal = matchedBatch?.product_name || productName || "-";
      let mrpLocal =
        matchedBatch?.price || matchedBatch?.mrp || barcodeData?.price || "-";

      if (!productCode || !batchCode) {
        const parts = val.split("-");
        const batchIndex = parts.findIndex((p) => p.toLowerCase() === "batch");

        if (batchIndex !== -1) {
          productCode = productCode || parts[batchIndex + 1] || productCode;
          batchCode = batchCode || parts.slice(batchIndex + 2).join("-");
        } else {
          productCode = productCode || parts[0] || productCode;
          batchCode = batchCode || parts.slice(1).join("-") || batchCode;
        }
      }

      const key = `${productCode || "UNKNOWN"}-${batchCode || "UNKNOWN"}`;

      if (!reportMap[key]) {
        reportMap[key] = {
          product_code: productCode || "-",
          product_name: productNameLocal || "-",
          batch_no: batchCode || "-",
          mrp: mrpLocal,
          count: 0,
        };
      }
      reportMap[key].count += 1;
    });

    return Object.values(reportMap);
  };

  const handleBarcodePrint = async () => {
    const printContent = document.getElementById("barcodePrintArea").innerHTML;
    const win = window.open("", "", "height=900,width=1200");
    
    // @ts-ignore - document.write is deprecated but works for printing
    win.document.write("<html><head><title>Barcode Print</title>");
    // @ts-ignore
    win.document.write(`
<style>
  @page {
    size: A4;
    margin: 0;
  }
  body {
    margin: 0;
    padding: 0;
    font-family: Arial, sans-serif;
  }

  .barcode-page {
    width: 210mm;
    height: 297mm;
    padding: 10mm;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10mm;
    box-sizing: border-box;
    page-break-after: always;
  }

  .barcode-label {
    border: 1px solid #dee2e6;
    border-radius: 8px;
    overflow: hidden;
    page-break-inside: avoid;
  }

  .label-header {
    background: #f8f9fa;
    padding: 8px 12px;
    border-bottom: 1px solid #dee2e6;
  }

  .info-line {
    display: flex;
    justify-content: space-between;
    margin-bottom: 4px;
    font-size: 11px;
  }

  .info-line:last-child {
    margin-bottom: 0;
  }

  .info-line .label {
    font-weight: 600;
    color: #495057;
  }

  .info-line .value {
    color: #212529;
  }

  .info-line .price {
    font-weight: 700;
    color: #2d5f2e;
  }

  .label-card {
    background: white;
    padding: 12px;
    text-align: center;
  }

  .product-title {
    font-size: 14px;
    font-weight: 700;
    color: #212529;
    margin-bottom: 6px;
  }

  .sku-display {
    font-size: 11px;
    color: #6c757d;
    margin-bottom: 8px;
    font-weight: 500;
  }

  .barcode-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px 0;
  }

  .barcode-container svg {
    max-width: 100%;
    height: auto;
  }

  .batch-info {
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid #e9ecef;
    font-size: 11px;
    color: #495057;
  }

  .batch-info > div {
    margin-bottom: 4px;
  }

  .batch-info > div:last-child {
    margin-bottom: 0;
  }

  .price-display {
    font-weight: 700;
    color: #2d5f2e;
    font-size: 12px;
  }

  .footer-note {
    background: #f8f9fa;
    padding: 6px;
    border-top: 1px solid #dee2e6;
    text-align: center;
    font-size: 10px;
    color: #6c757d;
    font-style: italic;
  }
</style>
`);

    // @ts-ignore
    win.document.write("</head><body>");
    // @ts-ignore
    win.document.write(printContent);
    // @ts-ignore
    win.document.write("</body></html>");
    win.document.close();
    win.print();

    try {
      const payload = {
        applicable_date:
          applicableDate || new Date().toISOString().split("T")[0],
        items: buildReportData().map((r) => {
          const matchedBatch = batchList.find(
            (b) =>
              String(b.batch_no).trim().replace(/\s+/g, "").toLowerCase() ===
                String(r.batch_no).trim().replace(/\s+/g, "").toLowerCase() &&
              String(b.product_code).trim() === String(r.product_code).trim()
          );

          return {
            batch_id: matchedBatch?.id || null,
            qty: r.count,
          };
        }),
      };

      await products_api.saveBarcodeReferences(payload);
    } catch (err) {
      console.error("Failed to save barcode references:", err);
    }

    setTimeout(() => setShowReportModal(true), 600);
  };

  const handleReportPrint = () => {
    const printContent = document.getElementById("reportPrintArea").innerHTML;
    const win = window.open("", "", "height=900,width=1200");
    
    // @ts-ignore
    win.document.write("<html><head><title>Report Print</title>");
    // @ts-ignore
    win.document.write(`
      <style>
        @page { size: A4; margin: 10mm; }
        body { font-family: Arial, sans-serif; }
        table {
          width: 100%;
          border-collapse: collapse;
          font-size: 12px;
        }
        th, td {
          border: 1px solid #000;
          padding: 6px;
        }
        tr {
          page-break-inside: avoid;
        }
      </style>
    `);
    // @ts-ignore
    win.document.write("</head><body>");
    // @ts-ignore
    win.document.write(printContent);
    // @ts-ignore
    win.document.write("</body></html>");
    win.document.close();
    win.print();
  };

  const chunkBarcodes = (arr, size) =>
    arr.reduce(
      (acc, _, i) => (i % size ? acc : [...acc, arr.slice(i, i + size)]),
      []
    );

  return (
    <>
      {/* ===== PREVIEW MODAL ===== */}
      <Modal
        opened={show && !showReportModal}
        onClose={onClose}
        title={
          <Flex justify="space-between" align="center" w="100%">
            <Text fw={600} style={{ margin: 20 }}>
              Batch Barcodes (Preview)
            </Text>

            <Flex align="center" gap="md">
              <Flex align="center" gap="xs">
                <Text size="sm" fw={500}>
                  Start Offset:
                </Text>
                <input
                  type="number"
                  min="0"
                  placeholder="0"
                  value={emptyOffset === 0 ? "" : emptyOffset}
                  onChange={(e) => {
                    const val = e.target.value;
                    setEmptyOffset(val === "" ? 0 : Number(val));
                  }}
                  style={{
                    width: "60px",
                    height: "30px",
                    borderRadius: "6px",
                    border: "1px solid #ccc",
                    padding: "4px 6px",
                    fontSize: "14px",
                    textAlign: "center",
                  }}
                />
              </Flex>

              <Flex align="center" gap="lg">
                <Text size="sm">
                  <b>Total Items:</b> {buildReportData().length}
                </Text>
                <Text size="sm">
                  <b>Total Count:</b> {initialQty}
                </Text>
              </Flex>

              <Button color="green" onClick={handleBarcodePrint}>
                Print
              </Button>
            </Flex>
          </Flex>
        }
        size="xl"
        fullScreen
        styles={{
          close: {
            backgroundColor: "#fac1c1ff",
            borderRadius: "50%",
            width: "32px",
            height: "32px",
            fontSize: "20px",
            color: "#ff0000ff",
            border: "1px solid #fdb3b3ff",
            transition: "all 0.2s ease",
            "&:hover": {
              backgroundColor: "#e9ecef",
              transform: "scale(1.1)",
            },
          },
        }}
      >
        <div style={{ maxWidth: "100%", margin: "0 auto", padding: 20 }}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(350px, 1fr))",
              gap: 20,
            }}
          >
            {selectedBarcodes.map((code, idx) => {
              const parts = code.split("-");
              const productCodeLocal = parts[0];
              const batchCodeLocal = parts.slice(1).join("-");

              const matchedProduct = productList.find(
                (p) => String(p.product_code) === String(productCodeLocal)
              );

              const matchedBatch = batchList.find(
                (b) => String(b.batch_code) === String(code)
              );

              const productNameLocal =
                matchedProduct?.product_name ||
                matchedProduct?.title ||
                productName;
              const priceLocal =
                matchedBatch?.price || matchedBatch?.mrp || price;

              return (
                <div
                  key={idx}
                  style={{
                    border: "1px solid #dee2e6",
                    borderRadius: 8,
                    background: "#fff",
                    position: "relative",
                    overflow: "hidden",
                  }}
                >
                  {/* Header */}
                  <div
                    style={{
                      background: "#f8f9fa",
                      padding: "12px 16px",
                      borderBottom: "1px solid #dee2e6",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: 6,
                        fontSize: 12,
                      }}
                    >
                      <span style={{ fontWeight: 600, color: "#495057" }}>
                        Product:
                      </span>
                      <span style={{ color: "#212529" }}>
                        {productNameLocal}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: 6,
                        fontSize: 12,
                      }}
                    >
                      <span style={{ fontWeight: 600, color: "#495057" }}>
                        SKU:
                      </span>
                      <span style={{ color: "#212529" }}>
                        {productCodeLocal}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: 6,
                        fontSize: 12,
                      }}
                    >
                      <span style={{ fontWeight: 600, color: "#495057" }}>
                        Batch:
                      </span>
                      <span style={{ color: "#212529" }}>{code}</span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: 12,
                      }}
                    >
                      <span style={{ fontWeight: 600, color: "#495057" }}>
                        Price:
                      </span>
                      <span style={{ color: "#2d5f2e", fontWeight: 700 }}>
                        ₹{priceLocal}
                      </span>
                    </div>
                  </div>

                  {/* Card Body */}
                  <div style={{ padding: 16, textAlign: "center" }}>
                    <div
                      style={{
                        fontSize: 16,
                        fontWeight: 700,
                        marginBottom: 8,
                      }}
                    >
                      {productNameLocal}
                    </div>
                    <div
                      style={{
                        fontSize: 12,
                        color: "#6c757d",
                        marginBottom: 12,
                      }}
                    >
                      SKU: {productCodeLocal}
                    </div>

                    <Barcode
                      value={code}
                      height={60}
                      width={1.8}
                      displayValue={true}
                      renderer="svg"
                    />

                    <div
                      style={{
                        marginTop: 12,
                        paddingTop: 12,
                        borderTop: "1px solid #e9ecef",
                        fontSize: 12,
                      }}
                    >
                      <div style={{ marginBottom: 4, color: "#495057" }}>
                        Batch: {batchCodeLocal}
                      </div>
                      <div
                        style={{
                          fontWeight: 700,
                          color: "#2d5f2e",
                          fontSize: 13,
                        }}
                      >
                        Price: ₹{priceLocal}
                      </div>
                    <div
                        style={{
                          fontSize: 11,
                          color: "#6c757d",
                          fontStyle: "italic",
                        }}
                      >
                        Product by Dheeram Trader
                      </div>
                    </div>
                  </div>

                  {/* Footer */}
                  <div
                    style={{
                      background: "#f8f9fa",
                      padding: "8px",
                      borderTop: "1px solid #dee2e6",
                      textAlign: "center",
                      fontSize: 11,
                      color: "#6c757d",
                      fontStyle: "italic",
                    }}
                  >
                    Scan this barcode for batch identification
                  </div>

                  {/* Remove Button */}
                  <button
                    onClick={() => removeBarcode(idx)}
                    style={{
                      position: "absolute",
                      top: 8,
                      right: 8,
                      border: "none",
                      background: "#fff",
                      cursor: "pointer",
                      color: "red",
                      fontSize: 18,
                      width: 24,
                      height: 24,
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                    }}
                  >
                    ✕
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      </Modal>

      {/* ===== REPORT MODAL ===== */}
      <Modal
        opened={showReportModal}
        onClose={() => setShowReportModal(false)}
        title={
          <Flex justify="space-between" align="center" w="100%">
            <Text fw={600} style={{ margin: 20 }}>
              Barcode Generation Report
            </Text>
            <Button color="green" onClick={handleReportPrint}>
              Print Report
            </Button>
          </Flex>
        }
        size="lg"
        styles={{
          close: {
            backgroundColor: "#fac1c1ff",
            borderRadius: "50%",
            width: "32px",
            height: "32px",
            fontSize: "20px",
            color: "#ff0000ff",
            border: "1px solid #fdb3b3ff",
            transition: "all 0.2s ease",
            "&:hover": {
              backgroundColor: "#e9ecef",
              transform: "scale(1.1)",
            },
          },
        }}
      >
        <div style={{ padding: 20 }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={{ border: "1px solid #000", padding: 8 }}>
                  Product Code
                </th>
                <th style={{ border: "1px solid #000", padding: 8 }}>
                  Product Name
                </th>
                <th style={{ border: "1px solid #000", padding: 8 }}>
                  Batch No
                </th>
                <th style={{ border: "1px solid #000", padding: 8 }}>MRP</th>
                <th style={{ border: "1px solid #000", padding: 8 }}>
                  Barcodes Generated
                </th>
              </tr>
            </thead>
            <tbody>
              {buildReportData().map((item, idx) => (
                <tr key={idx}>
                  <td style={{ border: "1px solid #000", padding: 8 }}>
                    {item.product_code}
                  </td>
                  <td style={{ border: "1px solid #000", padding: 8 }}>
                    {item.product_name}
                  </td>
                  <td style={{ border: "1px solid #000", padding: 8 }}>
                    {item.batch_no}
                  </td>
                  <td style={{ border: "1px solid #000", padding: 8 }}>
                    {item.mrp}
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      padding: 8,
                      textAlign: "center",
                    }}
                  >
                    {item.count}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Modal>

      {/* ===== HIDDEN PRINT AREA ===== */}
      <div
        id="barcodePrintArea"
        style={{
          position: "absolute",
          left: "-9999px",
          top: "-9999px",
        }}
      >
        {(() => {
          const offsetApplied = Array(emptyOffset)
            .fill("__EMPTY__")
            .concat(selectedBarcodes);

          const pages = chunkBarcodes(offsetApplied, 4);

          return pages.map((page, pageIndex) => (
            <div key={pageIndex} className="barcode-page">
              {page.map((code, i) => {
                if (code === "__EMPTY__") {
                  return <div key={i} className="barcode-label"></div>;
                }

                const parts = code.split("-");
                const productCodeLocal = parts[0];
                const batchCodeLocal = parts.slice(1).join("-");

                const matchedProduct = productList.find(
                  (p) => String(p.product_code) === String(productCodeLocal)
                );

                const matchedBatch = batchList.find(
                  (b) => String(b.batch_code) === String(code)
                );

                const productNameLocal =
                  matchedProduct?.product_name ||
                  matchedProduct?.title ||
                  productName;
                const priceLocal =
                  matchedBatch?.price || matchedBatch?.mrp || price;

                return (
                  <div key={i} className="barcode-label">
                    <div className="label-header">
                      <div className="info-line">
                        <span className="label">Product:</span>
                        <span className="value">{productNameLocal}</span>
                      </div>
                      <div className="info-line">
                        <span className="label">SKU:</span>
                        <span className="value">{productCodeLocal}</span>
                      </div>
                      <div className="info-line">
                        <span className="label">Batch:</span>
                        <span className="value">{code}</span>
                      </div>
                      <div className="info-line">
                        <span className="label">Price:</span>
                        <span className="value price">₹{priceLocal}</span>
                      </div>
                    </div>

                    <div className="label-card">
                      <div className="product-title">{productNameLocal}</div>
                      <div className="sku-display">
                        SKU: {productCodeLocal}
                      </div>

                      <div className="barcode-container">
                        <Barcode
                          value={code}
                          height={60}
                          width={1.8}
                          displayValue={true}
                          renderer="svg"
                        />
                      </div>

                      <div className="batch-info">
                        <div>Batch: {batchCodeLocal}</div>
                        <div className="price-display">
                          Price: ₹{priceLocal}
                        </div>
                                            <div
                        style={{
                          fontSize: 11,
                          color: "#6c757d",
                          fontStyle: "italic",
                        }}
                      >
                        Product by Dheeram Trader
                      </div> 
                      </div>
                    </div>

                    <div className="footer-note">
                      Scan this barcode for batch identification
                    </div>
                  </div>
                );
              })}
            </div>
          ));
        })()}
      </div>

      {/* ===== HIDDEN REPORT PRINT AREA ===== */}
      <div
        id="reportPrintArea"
        style={{
          position: "absolute",
          left: "-9999px",
          top: "-9999px",
        }}
      >
        <table>
          <thead>
            <tr>
              <th>Product Code</th>
              <th>Product Name</th>
              <th>Batch No</th>
              <th>MRP</th>
              <th>Barcodes Generated</th>
            </tr>
          </thead>
          <tbody>
            {buildReportData().map((item, idx) => (
              <tr key={idx}>
                <td>{item.product_code}</td>
                <td>{item.product_name}</td>
                <td>{item.batch_no}</td>
                <td>{item.mrp}</td>
                <td style={{ textAlign: "center" }}>{item.count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}